
import { customAxios } from "../service/customAxios";
import { useAuthStore } from "@/store/auth";


export function useUserData() {

  function getUserHandler() {
    return customAxios.get("/person/i");
  }

  async function updateUserInfo() {
    const { setProfile, userId } = useAuthStore();
    if (!userId) {
      return;
    }

    const r = await getUserHandler();
    setProfile(r.data);

    return r.data;
  }

   async function updateUserInfo2(user) {
    const { setProfile, userId } = useAuthStore();
       if (!userId) {
         return;
       }
   console.log("user: " + user)
      setProfile(user);
      return user;
    }

  async function getUserById(id) {
    return customAxios.get("/person/" + id);
  }

  function resetUserLocalStorage() {
    localStorage.removeItem("user");
    localStorage.removeItem("user-role");
    localStorage.removeItem("user-profile");
    localStorage.removeItem('acceptCookies');
  }

  return {
    resetUserLocalStorage,
    getUserHandler,
    updateUserInfo,
    updateUserInfo2,
    getUserById,
  };
}
